export default __webpack_public_path__ + "static/Montserrat-Medium-5db2134763a1767ebeac12b57fa2087d.woff2";